import { createUuid } from '~/_shared/utils/createUuid';
import {
  defaultBoundaryTerritoryGroupSettings, getDefaultLabelValueSettings,
} from '~/boundary/settings/defaultBoundarySettings';
import { getBoundaryTerritoryGroupSettingsStyleDefaults } from '~/boundary/settings/defaultBoundaryTerritoryStyles';
import { DATA_LAYER_TOOL_DEFAULT_NUMBER_OF_RANGES } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import type { DemographicIdCode } from '~/store/boundaryGroups/boundaryGroups.repository';
import type { DemographicRegion } from '~/store/demographics/demographics.types';
import type { DataLayerTemplate } from '~/store/frontendState/mapTools/dataLayers/dataLayers.repository';
import type {
  DataLayerGroup, DataLayerGroupId,
} from './mapSettingsDataLayers.state';

export const createDataLayerId = (): DataLayerGroupId => createUuid();

const DEFAULT_HIDE_BOUNDARY_NAME = true;
const DEFAULT_INCLUDE_LEGEND = false;
const DEFAULT_SHOW_VALUE = true;

export const createDataLayer = ({
  id, title, region, demographics, settings,
}: {
  title: string;
  region: DemographicRegion;
  demographics: ReadonlyArray<DemographicIdCode>;
} & Partial<DataLayerGroup>): DataLayerGroup => ({
  id: id || createDataLayerId(),
  data: {
    title,
    region,
    demographics: demographics || [],
  },
  settings: {
    ...getDefaultDataLayerSettings(),
    ...(settings ? settings : {}),
  },
});

export const getDefaultDataLayerSettings = () => ({
  style: getBoundaryTerritoryGroupSettingsStyleDefaults(),
  numberOfRanges: DATA_LAYER_TOOL_DEFAULT_NUMBER_OF_RANGES,
  disableMapInteraction: false,
  hideLabels: DEFAULT_HIDE_BOUNDARY_NAME,
  labelStyle: defaultBoundaryTerritoryGroupSettings.labelStyle,
  labelValueConfig: {
    ...getDefaultLabelValueSettings({ hideLabels: false }),
    includeLegend: DEFAULT_INCLUDE_LEGEND,
    showValue: DEFAULT_SHOW_VALUE,
  },
});

export const createDataLayerFromTemplate = (dataLayerTemplate: DataLayerTemplate): DataLayerGroup => ({
  ...createDataLayer({
    ...dataLayerTemplate.data.data,
    settings: dataLayerTemplate.data.settings,
  }),
  fromTemplate: dataLayerTemplate.id,
});
